import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

type formState = {
  userId: number;
  name: string;
  email: string;
  query: string;
  image_upload: File[];
  /** ALTCHA proof-of-work payload. Required by the requireCaptcha middleware. */
  altcha: string;
  /** Honeypot. Must stay empty; a value gets the request rejected. */
  contactReason: string;
};

export const RaiseQuery = async (FormState: formState) => {
  const { userId, name, email, query, image_upload, altcha, contactReason } = FormState;

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  };

  const base64Images: string[] = [];

  for (const file of image_upload) {
    const base64Image = await convertToBase64(file);
    base64Images.push(base64Image);
  }

  return securePost("/api/user/raiseConcern", {
    userId,
    name,
    email,
    query,
    image_upload: base64Images,
    altcha,
    contactReason,
  });
};